<template>
  <div class="mt-5">
    <div class="bg-light fixed-bottom">
      <div class="text-center p-2 footerInfo">
        <div class="versionsInfo">
          <div
            v-for="(version, index) in Object.values(versions)"
            :key="index"
            class="versions"
          >
            <div>
              {{ index === 0 ? `android: ${Object.values(versions)[0]}` : `` }}
            </div>
            <div>
              {{ index === 1 ? `backend: ${Object.values(versions)[1]}` : `` }}
            </div>
            <div>
              {{ index === 2 ? `ios: ${Object.values(versions)[2]}` : `` }}
            </div>
          </div>
          <div v-if="loggedUserStorage" class="logged-user">
            Zalogowany na: {{ loggedUserStorage }}
          </div>
          <div v-if="!loggedUserStorage && loggedUser" class="logged-user">
            Zalogowany na: {{ loggedUser }}
          </div>
        </div>

        <div>
          <b>&copy; SeniorApp {{ currentYear }}</b>
        </div>

        <div class="expirationTime">
          <b>{{ this.expTimerMessage }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      appVersions: [],
      expTimerMessage: "",
      timer: null,
      expTimeDate: null,
      refreshExpTimeDate: null,
      currentYear: "",
      refreshListNumbersInterval: null,
    };
  },

  created() {
    this.$store.dispatch("setExpirationTime");
    this.$store.dispatch("getApplicationsVersions");
    this.timer = setInterval(this.handleExpirationTime, 1000);
    window.addEventListener("mousemove", () => {
      this.mouseOrKeyboardEvent();
    });
    window.addEventListener("keypress", () => {
      this.mouseOrKeyboardEvent();
    });
    this.expTimeDate = moment(this.expTime * 1000).add(1, "hour");
    this.refreshExpTimeDate = moment(this.refreshExpTime * 1000).add(1, "hour");
    moment.locale("pl");
    this.currentYear = moment().format("YYYY");
  },
  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.refreshListNumbersInterval);
  },
  watch: {
    expTime() {
      this.expTimeDate = moment(this.expTime * 1000).add(1, "hour");
    },
    refreshExpTime() {
      this.refreshExpTimeDate = moment(this.refreshExpTime * 1000).add(
        1,
        "hour"
      );
    },
  },
  methods: {
    mouseOrKeyboardEvent() {
      this.$store.dispatch("refreshTokens");
    },
    handleExpirationTime() {
      const expTimeExpired = this.expTimeDate.isBefore(moment());
      const refreshExpTimeExpired = this.refreshExpTimeDate.isBefore(moment());
      if (expTimeExpired) {
        const date = new Date(this.refreshExpTime * 1000 - Date.now());
        const hours = date.getHours();
        const minutes = "0" + date.getMinutes();
        const seconds = "0" + date.getSeconds();
        this.expTimerMessage =
          "Pozostały czas sesji: " +
          (hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2));

        if (refreshExpTimeExpired) {
          this.$store.dispatch("logout");
        }
      } else {
        const date = new Date(this.refreshExpTime * 1000 - Date.now());
        const hours = date.getHours();
        const minutes = "0" + date.getMinutes();
        const seconds = "0" + date.getSeconds();
        this.expTimerMessage =
          "Pozostały czas sesji: " +
          (hours + ":" + minutes.substr(-2) + ":" + seconds.substr(-2));
        if (refreshExpTimeExpired) {
          this.$store.dispatch("logout");
        }
      }
    },
  },
  computed: {
    versions() {
      return this.$store.getters.getApplicationsVersions;
    },
    expTime() {
      return this.$store.getters.getExpirationTime;
    },
    refreshExpTime() {
      return this.$store.getters.getRefreshExpirationTime;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    loggedUserStorage() {
      return window.localStorage.getItem("loggedUser");
    },
  },
};
</script>
<style scoped>
.footerInfo {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.versions {
  font-size: 12px;
  flex-direction: column;
  display: flex;
  position: absolute;
  left: 0;
  bottom: -12px;
  font-weight: bold;
}
.logged-user {
  font-size: 12px;
  flex-direction: column;
  display: flex;
  position: absolute;
  left: 150px;
  bottom: 10px;
  font-weight: bold;
}
.versions div {
  margin-top: 4px;
}
.expirationTime {
  font-size: 12px;
}
.leftSide {
  display: flex;
  justify-content: flex-end;
}
.versionsInfo {
}
</style>
